import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";
import { vesselCapabilityService } from "@/app/services/generated/vesselcapabilityService";
import type { VesselCapability } from "@/app/services/generated/vesselcapabilityService";

// Singleton cache store
const vesselCapabilitiesCacheStore = new EntityCacheStore<VesselCapability>(
  EnumCacheEntityType.vesselCapability,
  async () => vesselCapabilityService.getAllVesselCapabilities()
);

// Ephemeral reader
export default class VesselCapabilitiesCache extends EntityWithGuidKeyCache<VesselCapability> {
  constructor() {
    super(vesselCapabilitiesCacheStore, (x) => x.id);
  }
}
